export class ApiUrl {
  /**
   * ApiUrl() gives the endpoint for the web api
   */
  public static webapiurl() {
    switch (window.location.host) {
      case 'visserijdashboard.wser.wur.nl':
        return 'https://visserijdashboard.wser.wur.nl/WebApi'
      case 'acc.visserijdashboard.wser.wur.nl':
        return 'https://acc.visserijdashboard.wser.wur.nl/WebApi'
      case 'tst.visserijdashboard.wser.wur.nl':
        return 'https://tst.visserijdashboard.wser.wur.nl/WebApi'

      default:
        return 'http://localhost:50256'
    }
  }
}
